// Shared voucher design library access for the email builder.
// The library = static editorial/abstract base + the salon's persisted
// custom designs, cached per session so the panel and the block editor
// don't refetch on every open.
import { DESIGNS } from '../../../../gift-cards-v2/data'
import { mergeDesigns } from '../../../../gift-cards-v2/giftCardMapper'
import { giftCardService } from '../../../../../_services/giftCard.service'

const BASE_DESIGNS = DESIGNS.filter(d => !d.isCustom)

let cachedLibrary = null

export const loadDesignLibrary = async () => {
  if (cachedLibrary) return cachedLibrary
  try {
    const persisted = await giftCardService.listDesigns()
    cachedLibrary = mergeDesigns(BASE_DESIGNS, persisted)
  } catch (err) {
    console.error('Design library load failed, using base library:', err)
    cachedLibrary = mergeDesigns(BASE_DESIGNS, [])
  }
  return cachedLibrary
}

// Map a library design onto voucher block content fields
export const designToContent = (design) => ({
  designId: design.id,
  aesthetic: design.aesthetic || 'editorial',
  theme: design.theme,
  template: design.occasion || 'signature',
  customDesign: design.isCustom && design.config ? design.config : null,
})

// The designs a voucher offers: curated subset when designIds is populated,
// otherwise every available design. Customs and the cover design lead.
export const designsForVoucher = (library, designIds, coverDesignId) => {
  const curated = designIds && designIds.length
    ? library.filter(d => designIds.includes(d.id))
    : library
  return curated
    .filter(d => d.available !== false)
    .sort((a, b) => {
      if (a.id === coverDesignId) return -1
      if (b.id === coverDesignId) return 1
      if (!!a.isCustom !== !!b.isCustom) return a.isCustom ? -1 : 1
      return 0
    })
}
